import { Helmet } from 'react-helmet-async';

const Seo = () => {
  const organizationData = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Conversify',
    url: 'https://conversify.org',
    logo: 'https://conversify.org/logo.png',
    description:
      'Find the right person, right now. Connect with verified experts across various fields and industries.',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+1-555-CONVERSIFY',
      contactType: 'customer service',
      availableLanguage: 'English',
    },
    sameAs: [
      'https://twitter.com/conversify',
      'https://linkedin.com/company/conversify',
      'https://facebook.com/conversify',
    ],
  };

  const websiteData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Conversify',
    description:
      'Find the right person, right now. Connect with verified experts across various fields and industries.',
    url: 'https://conversify.org',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://conversify.org/experts?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const serviceData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Expert Connection Service',
    description:
      'Connect with verified experts across various fields and industries for professional consultations.',
    provider: {
      '@type': 'Organization',
      name: 'Conversify',
    },
    serviceType: 'Professional Consultation',
    areaServed: 'Worldwide',
  };

  return (
    <Helmet>
      <script type="application/ld+json" data-cfasync="false">
        {JSON.stringify(organizationData)}
      </script>
      <script type="application/ld+json" data-cfasync="false">
        {JSON.stringify(websiteData)}
      </script>
      <script type="application/ld+json" data-cfasync="false">
        {JSON.stringify(serviceData)}
      </script>
    </Helmet>
  );
};

export default Seo;
